import * as React from 'react';
// import { BarChart } from '@mui/x-charts/BarChart';
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    LabelList,
    // Rectangle
} from 'recharts';
// import SquareIcon from '@mui/icons-material/Square';


export const OpenTasks = () => {

    const colors = ['31, 163, 84, 0.5', '255, 76, 134, 0.5']

    const data = [
        {label: 'Chakira Powers', completedValue: 20, notCompletedValue: 20},
        {label: 'Enxhi Berati', completedValue: 25, notCompletedValue: 10},
        {label: 'Ilda Gega', completedValue: 13, notCompletedValue: 5},
        {label: 'Jonian Abedini', completedValue: 45, notCompletedValue: 20},
        {label: 'Jurgen Bebja', completedValue: 89, notCompletedValue: 14},
        {label: 'Klaudio Dyrmishi', completedValue: 40, notCompletedValue: 25},
        {label: 'Krystal Gonzalez', completedValue: 89, notCompletedValue: 30},
        {label: 'Michelle Lugar', completedValue: 15, notCompletedValue: 10},
        {label: 'Reni Perez', completedValue: 45, notCompletedValue: 10},
        {label: 'TestMobileSms', completedValue: 45, notCompletedValue: 12},
    ];

    // const getTotal = (entry) => entry.completedValue + entry.notCompletedValue;
    // const renderCustomizedLabel = (props) => {
    //     const { x, y, width, value, index} = props;
    //     const total = getTotal(data[index]);

    //     const percentage = Math.round((value / total) * 100) ;

    //     return (
    //         <text x={x + width / 2} y={y + 15}  fill={"#192575"} textAnchor="middle" fontSize={14} fontWeight={500}>
    //             {percentage}%
    //         </text>
    //     );
    // };


    // const CustomTooltip = ({ active, payload, label }) => {
    //     if (active && payload && payload.length) {

    //         return (
    //             <div style={{ backgroundColor: "#2a2a2a",padding: "10px", border: "1px solid #ccc", borderRadius: "8px" }}>
    //                 <p style={{ fontWeight: "500",color:'#fff',marginBottom:'10px',paddingBottom:'5px', borderBottom:'1px solid #fff' }}>{label}</p>

    //                 {payload.map((entry, index) => (
    //                     <p key={index} style={{ color: entry.color }}>
    //                         {entry.name}: {entry.value}
    //                     </p>
    //                 ))}
    //             </div>
    //         );
    //     }
    //     return null;
    // };

    // const CustomLegend = (props) => {
    //     const { payload } = props;
    //     return (
    //         <ul style={{ display: 'flex', justifyContent: 'center' }}>
    //             {payload.map((entry, index) => (
    //                 <li key={`legend-item-${index}`} style={{ color: entry.color, marginRight: 50,listStyle:'none',display:'inline-flex',alignItems:'center',textTransform:'Capitalize'}}>
    //                     <SquareIcon/>
    //                     {entry.value}
    //                 </li>
    //             ))}
    //         </ul>
    //     );
    // };

    return (
        <Box sx={{padding:'10px 20px',width: "calc(100% - 40px)", height:'calc(100% - 20px)'}} className="openTaskBlock">
            <Box sx={{display:'flex',alignItems:'center',mb:3}}>
                <Typography variant="div" component="div" fontSize={'28px'} fontWeight="600" width={'max-content'} mr={3} color={'#2B3033'}>
                    Open tasks
                </Typography>
            </Box>
            <Box sx={{ width: "100%", height:'500px'}}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={data}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="label" angle={-45} textAnchor="end" height={80} />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="completedValue" fill={`rgba(${colors[0]})`} name="Completed">
                            <LabelList dataKey="completedValue" position="top" />
                        </Bar>
                        <Bar dataKey="notCompletedValue" fill={`rgba(${colors[1]})`} name="Not Completed">
                            <LabelList dataKey="notCompletedValue" position="top" />
                        </Bar>
                    </BarChart>
                    {/*<BarChart*/}
                    {/*    data={data}*/}
                    {/*>*/}
                    {/*    <CartesianGrid strokeDasharray="3 3" />*/}
                    {/*    <XAxis dataKey="label" interval={0} tick={({ x, y, payload }) => (*/}
                    {/*        <text x={x} y={y + 10} dy={-10} textAnchor="middle" fill="#666">*/}
                    {/*            {payload.value.split(" ").map((line, index) => (*/}
                    {/*                <tspan key={index} x={x} dy={index * 12} fontSize={'12px'}>*/}
                    {/*                    {line}*/}
                    {/*                </tspan>*/}
                    {/*            ))}*/}
                    {/*        </text>*/}
                    {/*    )} />*/}
                    {/*    <YAxis />*/}
                    {/*    <Tooltip content={<CustomTooltip />}/>*/}
                    {/*    <Legend verticalAlign="top"  wrapperStyle={{ paddingBottom: '40px'}} content={<CustomLegend />}/>*/}
                    {/*    <Bar dataKey="completedValue" stackId="a" fill="#8998eb" opacity={0.7} shape={<Rectangle sx={{'&:hover':{fill:'none'}}}/>}>*/}
                    {/*        <LabelList dataKey="completedValue" content={renderCustomizedLabel} />*/}
                    {/*    </Bar>*/}
                    {/*    <Bar dataKey="notCompletedValue" stackId="a" fill="#e56bef" opacity={0.5}>*/}
                    {/*        <LabelList dataKey="notCompletedValue" content={() => null}/>*/}
                    {/*    </Bar>*/}
                    {/*</BarChart>*/}
                </ResponsiveContainer>
            </Box>
        </Box>
    );
}